import Vue from 'vue';
import VueRouter from 'vue-router';
import store from '@/store';
import liveRouter from '@/router/liveRouter';

Vue.use(VueRouter);

const router = liveRouter;

export default router;
